//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/Object.js";
import "../no/Part.js";
let d=[[[0,"ActiveSheet",1,"Diagramming.Sheet",1]],[[[],"CreateBulkEditBuilder",{R_:{builder:"Diagramming.BulkEditBuilder"}},0,0],[["annotation"],"CreateCannedAnnotationBuilder",{R_:{builder:"Diagramming.CannedAnnotationBuilder"}},1,0],[["sheet"],"OpenSheet",{},1,1],[["sheet"],"CreateSheetSizeBuilder",{R_:{builder:"Diagramming.SheetSizeBuilder"}},1,0],[["sheet"],"CreateSheetTemplateBuilder",{R_:{builder:"Diagramming.SheetTemplateBuilder"}},1,0],[["inputObjects","nOutputObjects"],"CopySheetElements",{R_:{outputObjects:"NXObject[]"}},1,0]],[["Nodes","Diagramming.NodeCollection",0],["Sheets","Diagramming.SheetCollection",0],["Connections","Diagramming.ConnectionCollection",0],["Groups","Diagramming.GroupCollection",0],["Shapes","Diagramming.ShapeCollection",0],["Ports","Diagramming.PortCollection",0],["Annotations","Diagramming.AnnotationCollection",0],["Fills","Diagramming.FillCollection",0],["LeaderLines","Diagramming.LeaderLineCollection",0],["SheetBordersAndZones","Diagramming.SheetBordersAndZonesCollection",0],["Tables","Diagramming.Tables.TableCollection",0],["TitleBlocks","Diagramming.TitleBlockCollection",0],["Lines","Diagramming.Geometry.LineCollection",0],["Points","Diagramming.Geometry.PointCollection",0],["Rectangles","Diagramming.Geometry.RectangleCollection",0],["Arcs","Diagramming.Geometry.ArcCollection",0]]];
SPLM.Diagramming.DiagrammingManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Diagramming.DiagrammingManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;